import React from 'react';
import { Flex, Text, Divider as Divider$1 } from '@chakra-ui/react';

var Divider = function Divider(_ref) {
  var _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'sm' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$withText = _ref.withText,
      withText = _ref$withText === void 0 ? false : _ref$withText,
      _ref$wrapText = _ref.wrapText,
      wrapText = _ref$wrapText === void 0 ? false : _ref$wrapText,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text;
  /**
   * DOM
   */

  var divider = /*#__PURE__*/React.createElement(Divider$1, {
    "data-object-type": "core-divider",
    orientation: orientation,
    variant: variant,
    size: size
  });

  if (withText && orientation === 'horizontal') {
    return /*#__PURE__*/React.createElement(Flex, {
      justify: "center",
      padding: "none",
      wrap: wrapText ? 'wrap' : 'inherit',
      direction: "row",
      align: "center"
    }, divider, /*#__PURE__*/React.createElement(Text, {
      gap: '2xs',
      paddingBottom: 'xs',
      textAlign: "center",
      mx: "2",
      my: "0",
      textStyle: "divider",
      flex: "1 1 auto"
    }, text), divider);
  }

  return divider;
};

export { Divider };